$(document).on('ready', function () {
    window.Tools = window.Tools || {};
    Tools.$w = $(window);
    Tools.$b = $('body');
    Tools.xl = 1280;
    Tools.lg = 1024;
    Tools.md = 768;
    Tools.sm = 480;

    $.fn.lightBox = function () {
        $(this).each(function () {
            var $this = $(this);
            var $lightBox = $this.find('.js-lightbox');
            var $lightBoxItem = $this.find('.js-lightbox-item');
            var activeClass = 'active';
            var windowInnerWidth = window.innerWidth;
            var defaultParams = {
                hasThumb: true,
            }
            var settings = $.extend({}, defaultParams);

            $lightBox.magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Загрузка изображения...',
                mainClass: 'mfp-fade lightbox',
                fixedContentPos: true,
                modal: false,
                tClose: '',
                midClick: false,
                closeOnBgClick: true,
                gallery: {
                    enabled: true,
                    navigateByImgClick: false,
                    preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                    tPrev: '',
                    tNext: '',
                    closeOnBgClick: true,
                },
                zoom: {
                    enabled: true,
                    duration: 300, // don't foget to change the duration also in CSS
                    opener: function (element) {
                        return element.find('img');
                    }
                },
                image: {
                    markup:
                        '<div class="mfp-figure js-mfp-figure mfp-prevent-close">' +
                        '<button type="button" class="close js-popup-close">' +
                        '<svg class="i-close">' +
                        '   <use xlink:href="/img/event-img/ic-close.svg#ic-close"></use>' +
                        '</svg>' +
                        '</button>' +
                        '<div class="mfp-img js-mfp-img mfp-prevent-close">' +
                        '</div>' +
                        '</div>' +
                        '<div class="mfp-thumbnails thumbnails-list js-thumbnails mfp-prevent-close">' +
                        '</div>'// Popup HTML markup
                },
                callbacks: {
                    open: function () {
                        var instance = this;
                        var $thumbnailList = $(instance.contentContainer).find('.js-thumbnails');
                        var $figure = $(instance.contentContainer).find('.js-mfp-figure');
                        var $img = $(instance.contentContainer).find('.mfp-img');
                        var $thumbNail;
                        var preventCLoseClass = 'mfp-prevent-close';
                        var $arrows = $('.mfp-arrow');
                        var $content = $('.mfp-content');
                        var horizontalCoordinates;
                        if (windowInnerWidth >= Tools.md && settings.hasThumb) {
                            $lightBoxItem.each(function () {
                                var itemHref = $(this).attr('href');
                                $thumbnailList.append('<a href="' + itemHref + '" class="js-lightbox-item license-item-thumb mfp-prevent-close">' +
                                                        '<img src="' + itemHref + '" class="mfp-prevent-close" alt="" loading="lazy">' +
                                                    '</a>');
                            });
                        }

                        $(window).on('resize orientationchange onload', function () {
                            setPosition();
                        });

                        $arrows.each(function () {
                            $(this).append('<svg class="i-arrow mfp-prevent-close"><use xlink:href="/img/event-img/fc-arrow-prev.svg#fc-arrow-prev"></use></svg>');
                            $(this).css('top', $('.mfp-content').position().top + $figure.height() / 2);
                            $(this).addClass(preventCLoseClass);
                        });

                        $thumbNail = $thumbnailList.find('.js-lightbox-item');
                        var src = $img.attr('src');
                        $thumbNail
                            .filter('[href="' + src + '"]')
                            .addClass(activeClass)
                            .siblings()
                            .removeClass(activeClass);
                    },
                    imageLoadCompvare: function () {

                    },
                    beforeOpen: function () {


                    },
                    change: function () {
                        var instance = this;
                        var $lightBoxItem = $(instance.contentContainer).find('.js-lightbox-item');
                        var src = $(instance.contentContainer).find('.mfp-img').attr('src');
                        $lightBoxItem.removeClass(activeClass);
                        $lightBoxItem
                            .filter('[href="' + src + '"]')
                            .addClass(activeClass);
                        var $thumbnailList = $(instance.contentContainer).find('.js-thumbnails');

                        $thumbnailList.on('click', '.js-lightbox-item', function (e) {
                            e.preventDefault();
                            var itemHref = $(this).attr('href');
                            $.magnificPopup.instance.index = $(this).index();
                            $(this)
                                .addClass(activeClass)
                                .siblings()
                                .removeClass(activeClass);
                            var $figure = $('.js-mfp-figure');
                            $figure.html('<img src="' + itemHref + '" class="mfp-img mfp-prevent-close" alt="" loading="lazy">');

                        });

                    }
                }
            });


            /**
             * Закрытие лайтбокса
             */
            $(document).on('keyup', function (e) {
                if (e.keyCode === 27) {
                    $.magnificPopup.close();
                }
            });

            $(document).on('click', '.js-popup-close', function () {
                $.magnificPopup.close();
            });

        });
    };
    $('.js-lightbox-wrapper-without-thumb').each(function () {
        $(this).data('lightBox', $(this).lightBox());
    });

});
